import cacheSmartDocDataAction from '../actions/cacheSmartDocDataAction';
import { SmartDocData } from 'owa-mail-store';
import { ClientItem } from 'owa-mail-store';
import { mutator } from 'satcheljs';

export default mutator(cacheSmartDocDataAction, function cacheSmartDocDataMutator(actionMessage: {
    item: ClientItem;
    validPropertyExists: boolean;
    entityId?: string;
}) {
    // Falsy for these properties means we didn't find a valid property on the item.
    // We assign these values so that we don't bother fetching the property again.
    let smartDocData: SmartDocData = {
        EntityId: undefined,
    };

    const { item, validPropertyExists, entityId } = actionMessage;

    if (validPropertyExists) {
        smartDocData.EntityId = entityId;
    }

    item.SmartDocData = smartDocData;
});
